import moment from 'moment'

export function isToday(date) {
    return moment(date).startOf('day').isSame(moment().startOf('day'))
}

export function isThisWeek(date) {
    return moment(date).isSame(moment(), 'isoweek')
}

export function isThisMonth(date) {
    return moment(date).isSame(moment(), 'month')
}

export function isThisYear(date) {
    return moment(date).isSame(moment(), 'year')
}

export function isYesterday(date) {
    return moment(date).startOf('day').isSame(moment().subtract(1, 'days').startOf('day'))
}

export function isAfterToday(date) {
    return moment(date).isAfter(Date.now())
}

export function withinSpanChecker(start, end=Date.now()) {
    return date => {
        const momentDate = moment(date)
        return momentDate.isSameOrAfter(start) && momentDate.isSameOrBefore(end)
    }
}

export function spanWidthDays(span) {
    let { start, end } = span
    let momentStart = moment(start).startOf('day')
    let momentEnd = moment(end).endOf('day')

    return momentEnd.add(1, 'second').diff(momentStart, 'days')
}

export function subIntervalFor(interval) {
    switch (interval) {
        case 'Week': {
            return 'Day'
        }
        case 'Month': {
            return 'Week'
        }
        case 'Year': {
            return 'Month'
        }
        default:
            return
    }
}

function intervalToMoment(interval) {
    switch (interval) {
        case 'Day': {
            return 'day'
        }
        case 'Week': {
            return 'week'
        }
        case 'Month': {
            return 'month'
        }
        case 'Year': {
            return 'year'
        }
        default:
            return
    }
}

export function subdivide(span, interval) {
    const subInterval = subIntervalFor(interval)
    if (!subInterval) {
        return []
    }

    const spans = []

    let nextSpan = undefined

    while (!nextSpan || nextSpan.start < moment(span.end).subtract(1, intervalToMoment(subInterval)).valueOf()) {
        const nextStart = !nextSpan ? span.start : moment(nextSpan.start ).add(1, intervalToMoment(subInterval)).valueOf()
        nextSpan = getDefaultTimespan(subInterval, moment(nextStart).startOf('day').valueOf())
        spans.push( { ... nextSpan} )
    }

    return spans
}

export function getDefaultTimespan(interval, date=Date.now()) {
    let start, end
    if (interval == 'Day') {
        start = moment(date).startOf('day').valueOf()
        end = moment(date).endOf('day').valueOf()
    } else if (interval == '2 Days') {
        start = moment(date).startOf('day').valueOf()
        end = moment(date).add(1, "days").endOf('day').valueOf()
    } else if (interval == 'Week') {
        start = moment(date).startOf('isoweek').valueOf()
        end = moment(date).endOf('isoweek').valueOf()
    } else if (interval == '2 Weeks') {
        start = moment(date).startOf('isoweek').valueOf()
        end = moment(date).startOf('isoweek').add(13, 'days').endOf('day').valueOf()
    } else if (interval == '4 Weeks') {
        start = moment(date).startOf('isoweek').valueOf()
        end = moment(date).endOf('isoweek').add(3, 'weeks').valueOf()
    } else if (interval == 'Month') {
        start = moment(date).startOf('month').valueOf()
        end = moment(date).endOf('month').valueOf()
    } else if (interval == 'Quarter') {
        start = moment(date).startOf('quarter').valueOf()
        end = moment(date).endOf('quarter').valueOf()
    } else if (interval == 'Year') {
        start = moment(date).startOf('year').valueOf()
        end = moment(date).endOf('year').valueOf()
    } else if (interval == 'Custom') {
        start = moment(date).startOf('day').valueOf()
        end = moment(date).endOf('day').valueOf()
    }
    return {
        start: start,
        end: end,
    }
}

export function getDefaultTimespanBackward(interval, date=Date.now()) {
    let start, end
    if (interval == 'Day') {
        start = moment(date).startOf('day').valueOf()
        end = moment(date).endOf('day').valueOf()
    } else if (interval == '2 Days') {
        start = moment(date).subtract(1, "days").startOf('day').valueOf()
        end = moment(date).endOf('day').valueOf()
    } else if (interval == 'Week') {
        start = moment(date).startOf('isoweek').valueOf()
        end = moment(date).endOf('isoweek').valueOf()
    } else if (interval == '2 Weeks') {
        start = moment(date).startOf('isoweek').subtract(7, 'days').valueOf()
        end = moment(date).endOf('isoweek').endOf('day').valueOf()
    } else if (interval == '4 Weeks') {
        start = moment(date).startOf('isoweek').add(-3, 'weeks').valueOf()
        end = moment(date).endOf('isoweek').valueOf()
    } else if (interval == 'Month') {
        start = moment(date).startOf('month').valueOf()
        end = moment(date).endOf('month').valueOf()
    } else if (interval == 'Quarter') {
        start = moment(date).startOf('quarter').valueOf()
        end = moment(date).endOf('quarter').valueOf()
    } else if (interval == 'Year') {
        start = moment(date).startOf('year').valueOf()
        end = moment(date).endOf('year').valueOf()
    } else if (interval == 'Custom') {
        start = moment(date).startOf('day').valueOf()
        end = moment(date).endOf('day').valueOf()
    }
    return {
        start: start,
        end: end,
    }
}

export function dateRangeString(interval, span, options={short:false, hideYear:false}) {
    var start = moment(span.start)
    var end = moment(span.end)
    const { short, hideYear } = options
    const dateFmt = short ? 'D' : 'Do'
    const yearFmt = hideYear ? '' : 'YYYY'

    if (interval === 'Year') return start.format('YYYY')
    if (interval === 'Month') return start.format(`${ short ? 'MMM' : 'MMMM'} ${yearFmt}`)
    if (interval === 'Day') return start.format(`ddd MMM ${dateFmt} ${yearFmt}`)

    var startDateFormat, endDateFormat
    if (start.month() == end.month() && start.year() == end.year()) {
        startDateFormat = `MMM ${dateFmt}`
        endDateFormat = `${dateFmt} ${yearFmt}`
    } else if (start.year() == end.year()) {
        startDateFormat = `MMM ${dateFmt}`
        endDateFormat = `MMM ${dateFmt} ${yearFmt}`
    } else if ( short ) {
        startDateFormat = `MMM ${dateFmt}`
        endDateFormat = `MMM ${dateFmt} ${yearFmt}`
    } else {
        startDateFormat = `MMM ${dateFmt} ${yearFmt}`
        endDateFormat = `MMM ${dateFmt} ${yearFmt}`
    }
    return start.format(startDateFormat) + " - " + end.format(endDateFormat)
}

export function moveDays(span, interval, quantity) {
    return {
        start: moment(span.start).add(quantity, 'days').valueOf(),
        end: moment(span.end).add(quantity, 'days').valueOf(),
    }
}

export function moveSpan(span, interval, quantity) {
    if (interval == 'Day') {
        return moveDays(span, interval, quantity)
    }

    if (interval == 'Week') {
        return moveDays(span, interval, quantity * 7)
    }

    if (interval == '2 Weeks') {
        return moveDays(span, interval, quantity * 14)
    }

    return {
        start: moment(span.start).add(quantity, interval).valueOf(),
        end: moment(span.start).add(quantity, interval).endOf(interval).valueOf(),
    }
}

export function formatDateTs(timestamp, options={short:false, hideYear:false, hideDay: false}) {
    const { short, hideYear } = options
    const dateFmt = short ? 'D' : 'Do'
    const yearFmt = hideYear ? '' : 'YYYY'

    return moment(timestamp).format(`${options.hideDay? '' : 'ddd '}MMM ${dateFmt} ${yearFmt}`).trim()
}

export const formatDateTsAlt = (timestamp) => moment(timestamp).format("YYYY-MM-DD")


// WEBPACK FOOTER //
// ./src/util/date_utils.js